<template>
  <div>
    <EmailForm
      :duplicatecode="duplicatecode"
      :submitted="submitted"
      v-on:FormUpdate="FormUpdate"
      v-on:onSubmit="onSubmit($event)"
      @redirectPage="redirectPage"
    ></EmailForm>
  </div>
</template>
<script>
import EmailForm from "@/components/Form/EmailForm";
import { mapState } from "vuex";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  name: "EmailCreate",
  components: {
    EmailForm
  },
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false
    };
  },
  methods: {
    redirectPage() {
      this.$router.push({
        name: "EmailSettings",
        query: {
          tns_type: this.$route.query.tns_type
        }
      });
    },
    onSubmit(ev) {
      this.submitted = true;
      var url = this.$route.params.id
        ? "updatemailtemplate"
        : "createmailtemplate";
      // var success = this.$route.params.id ? "updated" : "created";
      var data = this.$route.params.id
        ? {
            id: this.$route.params.id,
            field: ev.data
          }
        : ev.data;
      this.$store
        .dispatch("settings/" + url, data)
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          if (this.code == 200) {
            //  show if sales-order successfully created
           
            this.$router.push({
              name:'EmailSettings',
              query:{tns_type:this.$route.query.tns_type}

            })
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.message,
              type: "success",
              showCloseButton: true
            });
          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
          //  code for notificatin display
        })
        .catch(() => {});
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      code: state => state.settings.code,
      message: state => state.settings.message
    })
  }
};
</script>